(function () {
  const timers = document.querySelectorAll('.countdown-timer');
  if (!timers.length) return;

  function format(distance) {
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((distance / (1000 * 60)) % 60);
    const seconds = Math.floor((distance / 1000) % 60);

    return (
      `${String(days).padStart(2, '0')}d ` +
      `${String(hours).padStart(2, '0')}:` +
      `${String(minutes).padStart(2, '0')}:` +
      `${String(seconds).padStart(2, '0')}`
    );
  }

  function onCountdownEnd(timerEl) {
    // ✅ O que acontece quando acaba (edite aqui)
    const container = timerEl.closest('.countdownContainer');

    // Exemplo 1: esconder a faixa
    container?.classList.add('hidden');

    // Exemplo 2: disparar evento global (se você quiser reagir em outro JS)
    document.dispatchEvent(new CustomEvent('promotion:ended'));
  }

  function updateOne(timerEl) {
    const promotionDate = timerEl.getAttribute('data-date-promotion');
    if (!promotionDate) return;

    const endDate = new Date(promotionDate).getTime();
    if (Number.isNaN(endDate)) return;

    const now = Date.now();
    const distance = endDate - now;

    if (distance <= 0) {
      timerEl.textContent = '00d 00:00:00';
      if (!timerEl.dataset.ended) {
        timerEl.dataset.ended = 'true';
        onCountdownEnd(timerEl);
      }
      return;
    }

    timerEl.textContent = format(distance);
  }

  function tick() {
    timers.forEach(updateOne);
  }

  tick();
  setInterval(tick, 1000);
})();
